var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('custom-select',{attrs:{"label":"Ocupación","value":_vm.value,"name":"ocupacion","items":_vm.ocupaciones,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }